import "@/App.css";
import "@/edit.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ContentProvider, useContent } from "@/context/ContentContext";
import { Navbar } from "@/components/Navbar";
import { EditToolbar } from "@/components/EditToolbar";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import ReadingRoom from "@/pages/ReadingRoom";
import Dashboard from "@/pages/Dashboard";
import BookingPage from "@/pages/BookingPage";
import BookingSuccess from "@/pages/BookingSuccess";
import ResetPassword from "@/pages/ResetPassword";

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center">
    <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground animate-pulse-glow">Consulting the cards...</p>
  </div>
);

const Gate = ({ children }) => {
  const { ready } = useContent();
  if (!ready) return <Loading />;
  return children;
};

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/auth" replace />;
  return children;
};

const AdminEntry = () => {
  const { user } = useAuth();
  const { enterEditMode } = useContent();
  useEffect(() => {
    if (user && user.role === "admin") enterEditMode();
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/auth" replace />;
  return <Navigate to="/" replace />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <Gate>
            <BrowserRouter>
              <Navbar />
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/auth" element={<AuthPage />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/admin" element={<AdminEntry />} />
                <Route path="/edit" element={<AdminEntry />} />
                <Route path="/reading" element={<Protected><ReadingRoom /></Protected>} />
                <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
                <Route path="/book" element={<BookingPage />} />
                <Route path="/booking/success" element={<Protected><BookingSuccess /></Protected>} />
              </Routes>
              <EditToolbar />
              <Toaster position="bottom-right" theme="dark" richColors />
            </BrowserRouter>
          </Gate>
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
